import { AsyncComponentRender } from '@components/AsyncComponent';
import { createTabs } from '@packages/tabs';

export const TABS = createTabs([
    ['profile', 'Profile', AsyncComponentRender(() => import('./Profile'))],
    ['billing', 'Billing', AsyncComponentRender(() => import('./Billing'))],
    ['addresses', 'Addresses', AsyncComponentRender(() => import('./Addresses'))],
    ['security', 'Security', AsyncComponentRender(() => import('./Security'))],
]);
